import React from 'react'
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Typography from '@mui/material/Typography';
import GitHubIcon from '@mui/icons-material/GitHub';
import YouTubeIcon from '@mui/icons-material/YouTube';



function Projects() {
  return (
    <div id="projects">
        <h1>My Projects</h1> 
        <div className="card">
            <div className="card-container">
                <Card sx={{ maxWidth: 345 }} id="sorting-card">
                    <CardHeader
                        title="NooR"
                        subheader="Rails | React | PostgreSQL | Three.js "
                    />
                    {/* <CardHeader  title="Sorting Visualizer">
                        
                    </CardHeader> */}
                    <img id="sorting-img" src="../noor.png" alt="" />
                    <CardContent>
                        <Typography variant="body2" color="text.secondary">
                            Share your projects and resumes templates on NooR to receive feedback from other users. NooR was created to help people make better projects and resumes. Users can like and post comments on projects as well as create and delete their own items.
                        </Typography>
                    </CardContent>
                    <CardActions disableSpacing>
                        <a className="project-link" target="_blank" href="https://github.com/srizvyy/final-project" rel="noreferrer"> 
                            {<GitHubIcon/>}
                        </a>
                        <a className="youtube" target="_blank" href="https://www.youtube.com/watch?v=KlP6UAHWDPk" rel="noreferrer">
                            {<YouTubeIcon id='youtube'/>}
                        </a>
                    </CardActions>
                        
                        
                    
                </Card>
                </div>
                <div className="card-container">
                <Card sx={{ maxWidth: 345 }} id="apptrack-card">
                    <CardHeader
                        title="AppTrack"
                        subheader="JavaScript | React | Ruby | Rails | Postgres"
                    />
                    <img className="image" src="../apptrack.png" alt="" />
                    <CardContent>
                        <Typography variant="body2" color="text.secondary">
                            AppTrack is an app that provides job-seekers with a tool to track where they have applied to and the status of their applications. Users can add job listings they've applied to and update them as they work through the interviewing process.
                        </Typography>
                    </CardContent>
                    <CardActions disableSpacing>
                         <a className="project-link" target="_blank" href="https://github.com/fitzgeraldkd/phase-3-sinatra-react-project" rel="noreferrer">
                            {<GitHubIcon/>}
                        </a>
                    </CardActions>
                        
                </Card>
                </div>
                <div className="card-container">

                <Card sx={{ maxWidth: 345 }} id="test">
                    <CardHeader
                        title="FunLeague" 
                        subheader='JavaScript | React | JSON'
                    />
                    <CardMedia
                        component="img"
                        height="194"
                        image="../funleague.png"
                        alt="Paella dish"
                    />
                    <CardContent>
                        <Typography variant="body2" color="text.secondary">
                            Want to play free video games? There are over 400 free video games to choice from on FunLeague. You can sort videos games based on genre or if you know the name then simply use the search to find the game. You can also post a video game as well. 
                        </Typography>
                    </CardContent>
                    <CardActions disableSpacing>
                          <a className="project-link" target="_blank" href="https://github.com/srizvyy/fun-league" rel="noreferrer">
                            {<GitHubIcon/>}
                        </a>
                        <div>
                        <a href="https://funleague.netlify.app/" target='_blank' rel="noreferrer"><button className='demo'>Demo</button></a>
                        </div>
                    </CardActions>
                </Card>
                </div>
                <div className="card-container">
                <Card sx={{ maxWidth: 345 }} id="test">
                    <CardHeader
                        title="CarMedia"
                        subheader="JavaScript | React | Rails | PostgreSQL"
                    />
                    <CardMedia
                        component="img"
                        height="194"
                        image="../carmedia.png"
                        alt="Paella dish"
                    />
                    <CardContent>
                        <Typography variant="body2" color="text.secondary">
                            CarMedia was created for car enthusiast people to share their favorite cars. Users can rate and favorite cars they like. Also, users can communicate with other users through comments. If you love cars then this the app for you. 
                        </Typography>
                    </CardContent>
                    <CardActions disableSpacing>
                          <a className="project-link" target="_blank" href="https://github.com/srizvyy/phase-4-project" rel="noreferrer">
                            {<GitHubIcon/>}
                        </a>
                    </CardActions>
                </Card>
                </div>
                <div className="card-container">
                <Card sx={{ maxWidth: 345 }} id="test">
                    <CardHeader
                        title="Keep It Moovy"
                        subheader="Vanilla JS"
                    />
                    <CardMedia
                        component="img"
                        height="194"
                        image="../moovy.png"
                        alt="Paella dish"
                    />
                    <CardContent>
                        <Typography variant="body2" color="text.secondary">
                            Having hard time searching for right movie to watch? Keep It Moovy has top highest rated movies ever. You can search movies based on genre or names. Click on the poster to find more information about the movie such description and rating 
                        </Typography>
                    </CardContent>
                    <CardActions disableSpacing>
                          <a className="project-link" target="_blank" href="https://github.com/fromwentzitcame/phase-1-group-project" rel="noreferrer">
                            {<GitHubIcon/>}
                        </a>
                    </CardActions>
                </Card>
                </div>
                <div className="card-container">
                <Card sx={{ maxWidth: 345 }} id="test">
                    <CardHeader
                        title="Advice of the Day"
                        subheader="JavaScript, React"
                    />
                    <CardMedia
                        component="img"
                        height="194"
                        image="../advice.png"
                        alt="Paella dish"
                    />
                    <CardContent>
                        <Typography variant="body2" color="text.secondary">
                           I created this app to inspire myself and others who might be feeling down for any reason. Advice of the day generates random advice, but if you don't like the advice then you have the option to click on the button to generate a new advice. 
                        </Typography>
                    </CardContent>
                    <CardActions disableSpacing>
                          <a className="project-link" target="_blank" rel="noreferrer" href="https://github.com/srizvyy/advice-generator">
                            {<GitHubIcon/>}
                        </a>
                         <div>
                        <a href="https://advice-of-the-day.netlify.app/" target='_blank' rel="noreferrer"><button className='demo'>Demo</button></a>
                        </div>
                    </CardActions>
                </Card>
            </div>
        </div>
            <div className="project-hr">
                <hr />
            </div>
  </div>
    );
}

export default Projects

                        
                        
                        
                        


        


            


